import React, { Component } from 'react'
import intl from 'react-intl-universal'
import Page from './Page'

class LoginFailedPage extends Component {
  render () {
    return (
      <Page title='Information'>
        <article className='b-info'>
          <h2 className='b-info-title'>{intl.get('Login failed')}</h2>
        </article>
      </Page>
    )
  }
}

export default LoginFailedPage



// WEBPACK FOOTER //
// ./src/containers/LoginFailedPage.js